// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/fonts/SourceHanSansCN.css' // 引入字体样式
Vue.config.productionTip = false
import BackToTop from './components/BackToTop.vue';
// import ViewUI from 'view-design';
// Vue.use(ViewUI);
import { Carousel, CarouselItem } from 'view-design';
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);
import 'view-design/dist/styles/iview.css';

Vue.component('BackToTop', BackToTop);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js